import autoImporter from '@modules/auto-importer';

const requireModal = require.context(
  './',
  true,
  /[a-zA-Z]\w+\.((component|directive|controller)\.js|ts|scss)$/
);

export const modals = autoImporter(requireModal);
